module.exports = __webpack_public_path__ + "static/media/icon-video-transparent.2902910d.svg";